import calculateShippingPrice from './calculateShippingPrice';
import { shippingConfig } from '../../config/shipping';
import { discountConfig } from '../../config/discounts';

/**
 * Format shipping price for display
 * @param {Object} method - Delivery method object with price, formatedPrice, slovakiaExtra
 * @param {string} customerCountry - Customer country ('cz', 'sk', or undefined)
 * @param {number} subTotal - Order subtotal (discounted price)
 * @returns {Object} - Object with text and showStrikethrough properties
 */
const formatShippingPrice = (method, customerCountry, subTotal) => {
  if (discountConfig.freeShippingForEverything || subTotal >= shippingConfig.freeShippingThreshold || method.price === 0) {
    return { text: "Zdarma", showStrikethrough: true };
  }
  
  const finalPrice = calculateShippingPrice(
    subTotal,
    method.price,
    method.slovakiaExtra || 0,
    customerCountry
  );
  
  if (!customerCountry) {
    return { text: `od ${method.formatedPrice}`, showStrikethrough: false };
  } else {
    return { text: `${finalPrice} Kč`, showStrikethrough: false };
  }
};

export default formatShippingPrice; 